import { MAX_PODS_DEFAULT } from './constants';

const normalizeAvailabilityZones = (zones) => {
    if (Array.isArray(zones)) return zones;
    if (zones) return [zones];
    return [];
};

export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const catalogService = data?.itemDetail?.catalogService || null;
    const catalogConfig = catalogService?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const applicationDetails = catalogConfig?.applicationDetails || null;
    const vmConfiguration = catalogConfig?.vmConfiguration || null;
    const nodeConfiguration = catalogConfig?.nodeConfiguration || null;
    const appProfile = entityDetails?.name || environmentDetails?.businessService || null;
    const project = catalogConfig?.project || null;
    const nodePoolName = catalogConfig?.nodePoolName || catalogConfig?.nodePool || null;
    const osSku = vmConfiguration?.osSku || null;
    const appOwnerGpid = applicationDetails?.edapPlatformOwner || environmentDetails?.applicationManagerGpid || entityDetails?.applicationManagerGpid || null;
    const appOwnerName = environmentDetails?.applicationManager || entityDetails?.applicationManager || null;
    const appOwnerEmail = environmentDetails?.applicationManagerEmail || entityDetails?.applicationManagerEmail || null;
    const appOwnerLabel = appOwnerGpid && appOwnerName ? `${appOwnerGpid} - ${appOwnerName}` : appOwnerGpid || appOwnerName || null;
    const costCenter = applicationDetails?.costCenter || environmentDetails?.costCenter || null;
    const supportContactGpid = applicationDetails?.supportContact || null;
    const businessContactGpid = applicationDetails?.businessContact || null;

    return {
        entityDetails: {
            ...entityDetails,
        },

        // Application Section
        projectName: catalogConfig?.projectName || null,
        appProfile,
        ...(appProfile && {
            appProfileDetails: { label: appProfile, value: appProfile, data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] } },
        }),
        sector: catalogConfig?.sector || entityDetails?.sector || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        region: environmentDetails?.region || catalogConfig?.region || null,
        environment: environmentDetails?.environment || catalogConfig?.environment || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        hCode: costCenter,
        ...(costCenter && {
            hCodeDetails: { label: costCenter, value: costCenter, projectName: environmentDetails?.projectName || null },
        }),
        ...(!costCenter && { hCodeDetails: null }),
        supportContact: null,
        supportContactDetails: supportContactGpid ? { gpid: supportContactGpid } : null,
        businessContact: null,
        businessContactDetails: businessContactGpid ? { gpid: businessContactGpid } : null,
        orgGroupCode: applicationDetails?.orgGroupCode || catalogConfig?.orgGroupCode || null,
        projectNumber: applicationDetails?.projectNumber || catalogConfig?.projectNumber || null,
        isaNumber: applicationDetails?.isaNumber || catalogConfig?.isaNumber || null,
        dataClassification: applicationDetails?.dataClassification || catalogConfig?.dataClassification || null,
        cloudOnboardingRequest: applicationDetails?.cloudOnboardingRequest || catalogConfig?.cloudOnboardingRequest || null,
        appOwner: appOwnerLabel,
        appOwnerDetails: {
            label: appOwnerLabel,
            gpid: appOwnerGpid,
            name: appOwnerName,
            email: appOwnerEmail,
        },

        // Resource
        resourceGroup: environmentDetails?.resourceGroup || catalogConfig?.resourceGroup || null,
        subscription: environmentDetails?.subscription || null,
        subscriptionDetails:
            environmentDetails?.subscriptionId || environmentDetails?.subscription
                ? {
                      subscriptionId: environmentDetails?.subscriptionId || null,
                      subscriptionName: environmentDetails?.subscription || null,
                  }
                : null,
        project,
        nodePoolName,
        nodePool: catalogConfig?.nodePool || catalogConfig?.nodePoolName || null,
        cluster: environmentDetails?.clusterName || catalogConfig?.cluster || catalogConfig?.clusterName || null,
        taints: catalogConfig?.taints || null,

        // VM Configuration
        vmType: vmConfiguration?.vmType || catalogConfig?.vmType || null,
        osType: vmConfiguration?.osType || catalogConfig?.osType || null,
        osSku,
        osSkuDetails: osSku ? { name: osSku } : null,
        osDiskType: vmConfiguration?.osDiskType || catalogConfig?.osDiskType || null,
        osDiskTypeDetails:
            vmConfiguration?.osDiskType || catalogConfig?.osDiskType
                ? {
                      label: vmConfiguration?.osDiskType || catalogConfig?.osDiskType,
                      value: vmConfiguration?.osDiskType || catalogConfig?.osDiskType,
                  }
                : null,
        osDiskSize: vmConfiguration?.osDiskTypeSize ?? catalogConfig?.osDiskSizeGB ?? catalogConfig?.osDiskTypeSize ?? null,
        availabilityZone: normalizeAvailabilityZones(vmConfiguration?.availabilityZones),
        availabilityZoneDetail: normalizeAvailabilityZones(vmConfiguration?.availabilityZones),
        availabilityZoneOptions: vmConfiguration?.availabilityZoneOptions || catalogConfig?.availabilityZoneOptions || null,
        isValidAvailabilityZone: true,

        // Node and Pod Configuration
        nodeCount: nodeConfiguration?.nodeCount ?? catalogConfig?.nodeCount ?? null,
        minNode: nodeConfiguration?.minNode ?? (catalogConfig?.minNode !== undefined ? catalogConfig?.minNode : null),
        maxNode: nodeConfiguration?.maxNode ?? catalogConfig?.maxNode ?? null,
        maxPods: nodeConfiguration?.maxPods ?? (catalogConfig?.maxPods !== undefined ? catalogConfig?.maxPods : MAX_PODS_DEFAULT),

        catalogCode: catalogService?.catalogServiceCode,
        catalogType: catalogService?.catalogType,
        cloudProvider: catalogService?.cloudProvider,
        cloudService: catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const applicationDetails = catalogConfig?.applicationDetails || null;
    const vmConfiguration = catalogConfig?.vmConfiguration || null;
    const nodeConfiguration = catalogConfig?.nodeConfiguration || null;
    const appProfile = entityDetails?.name || environmentDetails?.businessService || null;
    const project = catalogConfig?.project || null;
    const nodePoolName = catalogConfig?.nodePoolName || catalogConfig?.nodePool || null;
    const osSku = vmConfiguration?.osSku || null;
    const appOwnerGpid = applicationDetails?.edapPlatformOwner || environmentDetails?.applicationManagerGpid || entityDetails?.applicationManagerGpid || null;
    const appOwnerName = environmentDetails?.applicationManager || entityDetails?.applicationManager || null;
    const appOwnerEmail = environmentDetails?.applicationManagerEmail || entityDetails?.applicationManagerEmail || null;
    const appOwnerLabel = appOwnerGpid && appOwnerName ? `${appOwnerGpid} - ${appOwnerName}` : appOwnerGpid || appOwnerName || null;
    const costCenter = applicationDetails?.costCenter || environmentDetails?.costCenter || null;
    const supportContactGpid = applicationDetails?.supportContact || null;
    const businessContactGpid = applicationDetails?.businessContact || null;

    return {
        entityDetails: {
            ...entityDetails,
        },
        // Application Section
        projectName: catalogConfig?.projectName || null,
        appProfile,
        ...(appProfile && {
            appProfileDetails: { label: appProfile, value: appProfile, data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] } },
        }),
        sector: catalogConfig?.sector || entityDetails?.sector || null,
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,
        region: environmentDetails?.region || catalogConfig?.region || null,
        environment: environmentDetails?.environment || catalogConfig?.environment || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        hCode: costCenter,
        ...(costCenter && {
            hCodeDetails: { label: costCenter, value: costCenter, projectName: environmentDetails?.projectName || null },
        }),
        ...(!costCenter && { hCodeDetails: null }),
        supportContact: null,
        supportContactDetails: supportContactGpid ? { gpid: supportContactGpid } : null,
        businessContact: null,
        businessContactDetails: businessContactGpid ? { gpid: businessContactGpid } : null,
        orgGroupCode: applicationDetails?.orgGroupCode || catalogConfig?.orgGroupCode || null,
        projectNumber: applicationDetails?.projectNumber || catalogConfig?.projectNumber || null,
        isaNumber: applicationDetails?.isaNumber || catalogConfig?.isaNumber || null,
        dataClassification: applicationDetails?.dataClassification || catalogConfig?.dataClassification || null,
        cloudOnboardingRequest: applicationDetails?.cloudOnboardingRequest || catalogConfig?.cloudOnboardingRequest || null,
        appOwner: appOwnerLabel,
        appOwnerDetails: {
            label: appOwnerLabel,
            gpid: appOwnerGpid,
            name: appOwnerName,
            email: appOwnerEmail,
        },

        // Resource
        resourceGroup: environmentDetails?.resourceGroup || catalogConfig?.resourceGroup || null,
        subscription:
            environmentDetails?.subscription || environmentDetails?.subscriptionId || catalogConfig?.subscription || catalogConfig?.subscriptionId || null,
        subscriptionDetails:
            environmentDetails?.subscriptionId || environmentDetails?.subscription || catalogConfig?.subscriptionId || catalogConfig?.subscription
                ? {
                      subscriptionId: environmentDetails?.subscriptionId || catalogConfig?.subscriptionId || null,
                      subscriptionName: environmentDetails?.subscription || catalogConfig?.subscription || null,
                  }
                : null,
        project,
        nodePoolName,
        nodePool: catalogConfig?.nodePool || catalogConfig?.nodePoolName || null,
        cluster: environmentDetails?.clusterName || catalogConfig?.cluster || catalogConfig?.clusterName || null,
        taints: catalogConfig?.taints || null,

        // VM Configuration
        vmType: vmConfiguration?.vmType || catalogConfig?.vmType || null,
        osType: vmConfiguration?.osType || catalogConfig?.osType || null,
        osSku,
        osSkuDetails: osSku ? { name: osSku } : null,
        osDiskType: vmConfiguration?.osDiskType || catalogConfig?.osDiskType || null,
        osDiskTypeDetails:
            vmConfiguration?.osDiskType || catalogConfig?.osDiskType
                ? {
                      label: vmConfiguration?.osDiskType || catalogConfig?.osDiskType,
                      value: vmConfiguration?.osDiskType || catalogConfig?.osDiskType,
                  }
                : null,
        osDiskSize: vmConfiguration?.osDiskTypeSize ?? catalogConfig?.osDiskSizeGB ?? catalogConfig?.osDiskTypeSize ?? null,
        availabilityZone: normalizeAvailabilityZones(vmConfiguration?.availabilityZones),
        availabilityZoneDetail: normalizeAvailabilityZones(vmConfiguration?.availabilityZones),
        availabilityZoneOptions: vmConfiguration?.availabilityZoneOptions || catalogConfig?.availabilityZoneOptions || null,
        isValidAvailabilityZone: true,

        // Node and Pod Configuration
        nodeCount: nodeConfiguration?.nodeCount ?? catalogConfig?.nodeCount ?? null,
        minNode: nodeConfiguration?.minNode ?? (catalogConfig?.minNode !== undefined ? catalogConfig?.minNode : null),
        maxNode: nodeConfiguration?.maxNode ?? catalogConfig?.maxNode ?? null,
        maxPods: nodeConfiguration?.maxPods ?? (catalogConfig?.maxPods !== undefined ? catalogConfig?.maxPods : MAX_PODS_DEFAULT),

        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    entityDetails: null,
    appProfile: null,
    appProfileDetails: null,
    businessCategory: null,
    sector: null,
    sectorDetail: null,
    environment: null,
    region: null,
    regionDetail: null,
    applicationName: null,
    appShortName: null,
    supportContact: null,
    supportContactDetails: null,
    businessContact: null,
    businessContactDetails: null,
    orgGroupCode: null,
    projectNumber: null,
    projectName: null,
    isaNumber: null,
    dataClassification: null,
    cloudOnboardingRequest: null,
    appOwner: null,
    appOwnerDetails: null,

    // Resource
    resourceGroup: null,
    resourceGroupDetails: null,
    subscription: null,
    subscriptionDetails: null,
    project: null,
    nodePoolName: null,
    nodePool: null,
    cluster: null,
    clusterDetails: null,
    taints: null,

    // VM Configuration
    vmType: null,
    vmTypeDetails: null,
    osType: null,
    osSku: null,
    osSkuDetails: null,
    osDiskType: null,
    osDiskTypeDetails: null,
    osDiskSize: null,
    availabilityZone: [],
    availabilityZoneDetail: [],
    availabilityZoneOptions: null,
    isValidAvailabilityZone: true,

    // Node and Pod Configuration
    nodeCount: null,
    minNode: null,
    maxNode: null,
    maxPods: MAX_PODS_DEFAULT,

    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    validationStatus: null,
    isTouched: null,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
    isVmConfigOpen: false,
    isNodePodConfigOpen: false,
};
